import BrowserSprite from 'svg-baker-runtime/src/browser-sprite';
// social
import twitter from '../svg-icons/twitter.svg';
import instagram from '../svg-icons/instagram.svg';
import facebook from '../svg-icons/facebook.svg';
import linkedin from '../svg-icons/linkedin.svg';
import youtube from '../svg-icons/youtube.svg';
import vimeo from '../svg-icons/vimeo.svg';
// ui
// import chevronRight from '../svg-icons/chevron-right.svg';
// import chevronDown from '../svg-icons/chevron-down.svg';
// import chevronLeft from '../svg-icons/chevron-left.svg';
// import chevronUp from '../svg-icons/chevron-up.svg';
import cross from '../svg-icons/cross.svg';
import placeholder from '../svg-icons/placeholder.svg';
import arrowDown from '../svg-icons/arrow-down.svg';
import arrowRight from '../svg-icons/arrow-right.svg';
import arrowLeft from '../svg-icons/arrow-left.svg';
import arrowUpRight from '../svg-icons/arrow-up-right.svg';
import arrowDownLeft from '../svg-icons/arrow-down-left.svg';
